import { getName } from "@/global";
import { DELEGATE_INFO } from "@/resources/constants";
import TooltipText from "../TooltipText";

const isCurrentDelegate = (delegate: any) => {
  const now = Date.now();
  if (delegate.from && delegate.from > now) return false;
  const until = delegate.until ?? delegate.to;
  if (until && until < now) return false;
  return true;
};

const PatientName = (props: any) => {
  const { encounter, ...otherProps } = props;
  if (!encounter || !encounter.patient) return '-';
  const nameInfo = getName(encounter);
  const name = nameInfo.fromPatient || nameInfo.fromDelegate || "-";

  const delegateNameDiffers = !!nameInfo.fromDelegate && nameInfo.fromDelegate !== nameInfo.fromPatient;
  const currentDelegate = encounter.delegates?.find(isCurrentDelegate);
  const providedLabel = currentDelegate?.canAct === true ? "Delegate provided" : "Accompanying person provided";
  const warning = delegateNameDiffers;
  
  let tooltipText;
  if (delegateNameDiffers) {
    if (nameInfo.external) {
      tooltipText = `Patient provided: ${nameInfo.external}\n${providedLabel}: ${nameInfo.fromDelegate}`;
    } else {
      tooltipText = `${providedLabel}: ${nameInfo.fromDelegate}`;
    }
  } else if (nameInfo.external) {
    tooltipText = `Patient provided: ${nameInfo.external}`;
  }

  return (
    <TooltipText
      text={name}
      warning={warning}
      sx={{ maxWidth: "fit-content" }}
      {...otherProps}
    >
      {tooltipText}
    </TooltipText>
  );
};

export default PatientName
